import { createFileRoute, redirect } from '@tanstack/react-router';
import { getActiveBrandId } from '../lib/active-brand.js';
import { brandsQuery, meQuery } from '../lib/queries.js';

// Bookmark-compat redirector for the top-nav Creative tab. Per-brand
// creative playground lives at /brand/<slug>/creative.
export const Route = createFileRoute('/creative')({
  beforeLoad: async ({ context: { queryClient } }) => {
    // Creative playground is dev-only (s265) — bounce to /home in prod
    // so a typed/bookmarked URL doesn't expose it. See top-nav.tsx.
    if (!import.meta.env.DEV) throw redirect({ to: '/home' });
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const live = brands.filter((b) => b.archivedAt === null);
    const activeId = getActiveBrandId();
    const target = live.find((b) => b.id === activeId) ?? live[0];
    if (!target) throw redirect({ to: '/brands' });
    throw redirect({ to: '/brand/$slug/creative', params: { slug: target.slug } });
  },
  component: () => null,
});
